import { Response } from "@/common/entity/Response";
import { IUser } from "@/common/entity/User";
import { WxLoginQrCode } from "@/common/entity/WxLoginQrCode";
import { request, UrlPath } from "..";
import { IWxOrder } from "@/common/entity/WxOrder";

export enum LoginStatus {
    STATUS_SUCCESS = 0,
    STATUS_WAIT_SCAN = 1,
    STATUS_SCANED = 2,
    STATUS_REFRESH = 3,
}

export type LoginStatusRespData = {
    /**
     * 是否为新用户
     */
    isNew: boolean;
    /**
     * 用户信息
     */
    user: IUser;
    /**
     * 用户状态
     */
    status: LoginStatus;
    /**
     * 登录状态是否异常
     */
    hasException: boolean;
};

/**
 * 获取登录二维码
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 */
function loginQrCode(
    isShowToast: boolean = true
): Promise<WxLoginQrCode> {
    return request<WxLoginQrCode>(UrlPath.loginQrCode, isShowToast);
}

/**
 *
 * @param ticket 在"获取登录二维码“接口{@link loginQrCode()}中获取到的ticket
 */
function qrCodeLoginStatus(
    ticket: string,
    isShowToast: boolean = true
): Promise<LoginStatusRespData> {
    return request<LoginStatusRespData>(
        { url: UrlPath.loginQrCodeStatus, data: { ticket } },
        isShowToast
    );
}

/**
 * 获取对应支付套餐的支付二维码
 * @param payPkgId 支付套餐id
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 * @returns 成功时返回{@link IWxOrder 信息订单数据}，失败时返回{@link Response 响应对象}
 */
function payQrCode(
    payPkgId: number,
    isShowToast: boolean = true
): Promise<IWxOrder> {
    return request<IWxOrder>(
        { url: UrlPath.wxPayQrCode, data: { payPkgId } },
        isShowToast
    );
}

/**
 * 查询微信订单
 */
function queryOrder(orderId: number, isShowToast: boolean) {
    return request<{ order: IWxOrder; user?: IUser }>({
        url: UrlPath.queryWxOrder,
        data: { orderId },
    }, isShowToast);
}

export const WechatApi = {
    payQrCode,
    queryOrder,
    loginQrCode,
    qrCodeLoginStatus,
};
